<template> 
    <div class="page-footer-inrs">
      <b-navbar
      :class="'footer-bar'"
      id="navbarinrs"
      >
          <b-navbar-nav>
              <div class="links">
                  <a :href="$t('components.pageFooterInrs.cguLink.href')">{{$t('components.pageFooterInrs.cguLink.title')}}</a>
                  <a :href="$t('components.pageFooterInrs.privacyLink.href')">{{$t('components.pageFooterInrs.privacyLink.title')}}</a>
                  <a :href="$t('components.pageFooterInrs.cookiesLink.href')">{{$t('components.pageFooterInrs.cookiesLink.title')}}</a>
              </div>
              <div class="credentials">
                  {{$t('components.pageFooterInrs.credentials')}}
              </div>
          </b-navbar-nav>
      </b-navbar>
    </div>
</template>

<script>

export default {
  name: 'PageFooterInrs',
  components: {
  },
  data: function() {
      return {
      }
  },
  computed: {
  },
  props: {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../sass/_variables.sass"
@import "../sass/_media.sass"

.navbar
  background-color: #4C4C50
  min-height: 40px
  margin: 0
  padding: 0
  position: relative
  bottom: 0

  .navbar-nav
    display: flex
    flex-direction: row
    flex-wrap: wrap
    justify-content: center
    align-items: center
    gap: 40px
    width: 100%
    color: white
    font-weight: 700
    font-size: 14px

    .links
      display: flex
      flex-wrap: wrap
      justify-content: center
      gap: 40px
      a
        color: white
        text-decoration: none
        &:hover
          text-decoration: underline
</style>
